import {
  AccountActiveTicketListResponse,
  AccountCartLifetimeResponse,
  CustomerCardDetailVm,
  CustomerCardResponse,
  CustomerHeaderVm,
  DeleteCustomerAccountCommand,
  EshopCustomerAccountController,
  EshopCustomerAccountControllerGetAccountRelatedCustomersData,
} from '@/api';
import { getQueryParams, getRequestBody } from '@/utils/api.ts';

export default {
  getAccountRelatedCustomerList: async (
    query: EshopCustomerAccountControllerGetAccountRelatedCustomersData['query'],
  ): Promise<CustomerHeaderVm[]> => {
    const response = await EshopCustomerAccountController.getAccountRelatedCustomers({
      query: getQueryParams(query),
    });

    return response.data?.data ?? [];
  },

  getActiveTicketsList: async (): Promise<AccountActiveTicketListResponse> => {
    const response = await EshopCustomerAccountController.getAccountActiveTickets();
    return response.data!;
  },

  removeCustomerAccount: async (payload: DeleteCustomerAccountCommand): Promise<void> => {
    await EshopCustomerAccountController.removeCustomerAccount({
      body: getRequestBody(payload),
    });
  },

  getCustomerAccountCartLifetime: async (): Promise<AccountCartLifetimeResponse> => {
    const response = await EshopCustomerAccountController.getCustomerCartLifeTime();
    return response.data!;
  },

  nullCustomerAccountCartLifeTime: async (): Promise<void> => {
    await EshopCustomerAccountController.nullCustomerCartLifetime();
  },

  changeChildAccountToRegularAccount: async (): Promise<void> => {
    await EshopCustomerAccountController.changeChildAccountToRegularAccount();
  },
  isEmailUsed: async (email: string): Promise<boolean | undefined> => {
    const response = await EshopCustomerAccountController.verifyEmailExists({
      path: {
        email,
      },
    });
    return response.data?.data;
  },
  getCustomerLastActiveCard: async (customerId: string): Promise<CustomerCardDetailVm> => {
    const response = await EshopCustomerAccountController.getCustomerLastActivePortableCard(
      customerId ? { query: { customerId } } : {},
    );
    return (response.data as CustomerCardResponse).data;
  },
};
